// GENERATED by scripts/gen-hooks.mjs. Do not edit by hand.
// 22 hooks for backend/banking.

import { useBackend } from '../useBackend'

/** POST /api/banking/allocateDeposit */
export function useAllocateDeposit<T = any>() {
  return useBackend<T>('banking/allocateDeposit')
}

/** POST /api/banking/clearCashPlanOverride */
export function useClearCashPlanOverride<T = any>() {
  return useBackend<T>('banking/clearCashPlanOverride')
}

/** POST /api/banking/enterCashBalance */
export function useEnterCashBalance<T = any>() {
  return useBackend<T>('banking/enterCashBalance')
}

/** POST /api/banking/getBankAccounts */
export function useGetBankAccounts<T = any>() {
  return useBackend<T>('banking/getBankAccounts')
}

/** POST /api/banking/getCashPlan */
export function useGetCashPlan<T = any>() {
  return useBackend<T>('banking/getCashPlan')
}

/** POST /api/banking/getCashPlanAccess */
export function useGetCashPlanAccess<T = any>() {
  return useBackend<T>('banking/getCashPlanAccess')
}

/** POST /api/banking/getStatementAccess */
export function useGetStatementAccess<T = any>() {
  return useBackend<T>('banking/getStatementAccess')
}

/** POST /api/banking/getStatementDocumentUrl */
export function useGetStatementDocumentUrl<T = any>() {
  return useBackend<T>('banking/getStatementDocumentUrl')
}

/** POST /api/banking/getStatementGaps */
export function useGetStatementGaps<T = any>() {
  return useBackend<T>('banking/getStatementGaps')
}

/** POST /api/banking/getStatementLibrary */
export function useGetStatementLibrary<T = any>() {
  return useBackend<T>('banking/getStatementLibrary')
}

/** POST /api/banking/getUnmatchedBankCredits */
export function useGetUnmatchedBankCredits<T = any>() {
  return useBackend<T>('banking/getUnmatchedBankCredits')
}

/** POST /api/banking/ingestBankStatement */
export function useIngestBankStatement<T = any>() {
  return useBackend<T>('banking/ingestBankStatement')
}

/** POST /api/banking/matchDeposits */
export function useMatchDeposits<T = any>() {
  return useBackend<T>('banking/matchDeposits')
}

/** POST /api/banking/proposeDepositMatches */
export function useProposeDepositMatches<T = any>() {
  return useBackend<T>('banking/proposeDepositMatches')
}

/** POST /api/banking/removeCashBalance */
export function useRemoveCashBalance<T = any>() {
  return useBackend<T>('banking/removeCashBalance')
}

/** POST /api/banking/removeStatementUpload */
export function useRemoveStatementUpload<T = any>() {
  return useBackend<T>('banking/removeStatementUpload')
}

/** POST /api/banking/runCreditAttribution */
export function useRunCreditAttribution<T = any>() {
  return useBackend<T>('banking/runCreditAttribution')
}

/** POST /api/banking/saveBankAccount */
export function useSaveBankAccount<T = any>() {
  return useBackend<T>('banking/saveBankAccount')
}

/** POST /api/banking/saveCashPlanOverride */
export function useSaveCashPlanOverride<T = any>() {
  return useBackend<T>('banking/saveCashPlanOverride')
}

/** POST /api/banking/saveCashPlanRow */
export function useSaveCashPlanRow<T = any>() {
  return useBackend<T>('banking/saveCashPlanRow')
}

/** POST /api/banking/saveCashPlanSettings */
export function useSaveCashPlanSettings<T = any>() {
  return useBackend<T>('banking/saveCashPlanSettings')
}

/** POST /api/banking/uploadBankStatementPdf */
export function useUploadBankStatementPdf<T = any>() {
  return useBackend<T>('banking/uploadBankStatementPdf')
}
